import React, { FC, useContext /* useLayoutEffect, useRef, useState */ } from 'react';
import { useRouter } from 'next/navigation';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
// import MarketButtonMobile from 'components/commercetools-ui/organisms/market-button/market-button-mobile';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import MobileMenuNavButton from '../atoms/menu-nav-button';

export interface Props {
  showMenu: boolean;
  insertCategory: (category: Category) => void;
  hideHeaderMenu: () => void;
}

const MobileMenuFooter: FC<Props> = ({ /* showMenu, */ hideHeaderMenu, insertCategory }) => {
  const router = useRouter();
  const { formatMessage } = useFormat({ name: 'common' });
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { account, logout } = useContext(AccountContext);

  /* For now, we do not want to use the MarketButton because it doesn't fit the design.
  If in the future we decide to use it, we need to uncomment the following line: */

  // const marketButtonRef = useRef<HTMLDivElement>(null);
  // const [languageMenuTop, setLanguageMenuTop] = useState(false);

  const tabs = [
    { name: formatAccountMessage({ id: 'my.account', defaultMessage: 'My Account' }), href: '/account' },
    { name: formatAccountMessage({ id: 'orders', defaultMessage: 'Orders' }), href: '/account/?hash=orders' },
    {
      name: formatAccountMessage({ id: 'customer.support', defaultMessage: 'Customer support' }),
      href: '/account/?hash=support',
    },
  ];

  const accountButton: Category = {
    categoryId: 'myAccount',
    name: formatAccountMessage({ id: 'my.account', defaultMessage: 'My Account' }),
    depth: 1,
    descendants: tabs.map((tab) => {
      return { categoryId: tab.href, name: tab.name, slug: tab.href, _url: tab.href, descendants: [], depth: 1 };
    }),
  };

  const handleLogout = () => {
    logout().then(() => router.push('/login'));
    hideHeaderMenu();
  };

  // For now, we do not want to use the MarketButton because it doesn't fit the design.
  // If in the future we decide to use it, we need to uncomment the useLayoutEffect below:
  /*
  useLayoutEffect(() => {
    if (marketButtonRef.current) {
      if (window.innerHeight - marketButtonRef.current.getBoundingClientRect().bottom < 100)
        setLanguageMenuTop(true);
      else setLanguageMenuTop(false);
    }
  }, [showMenu]);
  */

  return (
    <>
      <div className="w-full border border-stroke-primary" />

      {account ? (
        <div className="mx-24 block pt-32">
          <MobileMenuNavButton
            link={accountButton}
            onClick={() => insertCategory(accountButton)}
            hideHeaderMenu={hideHeaderMenu}
          />
        </div>
      ) : (
        <div className="mx-24 block pt-32">
          <Link link="/help" onClick={hideHeaderMenu} className="py-16">
            <Typography className="text-14 text-primary-black">
              {formatMessage({ id: 'help.and.support', defaultMessage: 'Help & Customer Service' })}
            </Typography>
          </Link>{' '}
        </div>
      )}

      <div className="mx-24 flex py-32">
        {account ? (
          <Button variant="ghost" size="fit" onClick={handleLogout}>
            <Typography className="body-text-small font-normal leading-6 text-text-primary">
              {formatAccountMessage({ id: 'sign.out', defaultMessage: 'Sign out' })}
            </Typography>
          </Button>
        ) : (
          <Link link="/login" onClick={hideHeaderMenu} className="px-0">
            <Typography className="body-text-small leading-6 text-text-primary">
              {formatAccountMessage({ id: 'sign.in', defaultMessage: 'Sign In' })}
            </Typography>
          </Link>
        )}
      </div>
      {/* For now, we do not want to use the MarketButton because it doesn't fit the design.
          If in the future we decide to use it, please uncomment the following block. */}
      {/*
      {/* <div className="p-16" ref={marketButtonRef}>
        <MarketButtonMobile menuTop={languageMenuTop} />
      </div> */}
    </>
  );
};

export default MobileMenuFooter;
